<template>
  <div class="badge blue600">
    <i :class="icon"></i>
    <span class="head-regular">{{ text }}</span>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
    },
    text: {
      type: String,
    },
  },
};
</script>

<style scoped lang="scss">
.badge {
  border: 1px solid #001e50;
  padding: 8px 12px;
  display: inline-flex;
  align-items: center;
  i {
    margin-right: 8px;
    font-size: 14px;
  }
}
</style>
